
  import CapsuleInputDate from "../../../view_elements/CapsuleInputDate.vue";
  import CapsuleLabelInput from "../../../view_elements/CapsuleLabelInput.vue";

  export default {
    name: "RecurrenceModal",
    components: {
      CapsuleInputDate,
      CapsuleLabelInput
    },
    props: {
      initialDate: Date,
      endDate: Date,
      datesFrom: Date,
      datesTo: Date
    },
    data() {
      return {
        dayOfMonth: 1,
        monthsRecurrence: 1,
        repeatOption: "day",
        weekOfMonth: 1,
        dayOfWeek: 1,
        text: {
          recurrence: this.$t("recurrence"),
          start: this.$t("start"),
          repeatEvery: this.$t("repeatEvery"),
          months: this.$tc("month", 2),
          the: this.$tc("the", 1),
          day: this.$tc("day", 1),
          end: this.$tc("end", 1),
          weekdays: [
            this.$tc("monday", 2),
            this.$tc("tuesday", 2),
            this.$tc("wednesday", 2),
            this.$tc("thursday", 2),
            this.$tc("friday", 2)
          ],
          ordinalNumber: [
            this.$tc("first", 1),
            this.$tc("second", 1),
            this.$tc("third", 1),
            this.$tc("fourth", 1),
            this.$tc("last", 1)
          ]
        }
      };
    },
    methods: {
      validateMonth() {
        if (this.monthsRecurrence < 1) this.monthsRecurrence = 1;
        else if (this.monthsRecurrence > 12) this.monthsRecurrence = 12;
      },
      editInitialDate(value) {
        this.$emit("setInitialDate", value);
      },
      editEndDate(value) {
        this.$emit("setEndDate", value);
      },
      calculateDates() {
        // Check if interval is provided
        if (this.initialDate == null || this.endDate == null) return;

        const recurrenceDate = this.$moment(this.initialDate);
        const endDateRecurrence = this.$moment(this.endDate);
        const dates: Array<Date> = [];
        if (this.repeatOption == "day") {
          recurrenceDate.add(this.monthsRecurrence, "months");
          recurrenceDate.date(this.dayOfMonth);
          while (!recurrenceDate.isAfter(endDateRecurrence)) {
            dates.push(recurrenceDate.format("YYYY-MM-DD"));
            recurrenceDate.add(this.monthsRecurrence, "months");
          }
        } else if (this.repeatOption == "weekday") {
          if (this.weekOfMonth === 5) {
            while (!recurrenceDate.isAfter(endDateRecurrence)) {
              // Find the last occurrence of the given weekday in the month
              recurrenceDate.endOf("month");
              while (recurrenceDate.day() !== this.dayOfWeek) {
                recurrenceDate.subtract(1, "day");
              }
              if (
                !recurrenceDate.isAfter(endDateRecurrence) &&
                recurrenceDate.isSameOrAfter(this.initialDate)
              ) {
                dates.push(recurrenceDate.format("YYYY-MM-DD"));
              }
              recurrenceDate.add(this.monthsRecurrence, "months");
            }
          } else {
            while (!recurrenceDate.isAfter(endDateRecurrence)) {
              // Find the first occurrence of the given weekday
              recurrenceDate.startOf("month");
              recurrenceDate.day(this.dayOfWeek);
              if (recurrenceDate.date() > 7) {
                recurrenceDate.add(1, "weeks");
              }

              // Move to the correct week
              recurrenceDate.add(this.weekOfMonth - 1, "weeks");

              if (
                !recurrenceDate.isAfter(endDateRecurrence) &&
                recurrenceDate.isSameOrAfter(this.initialDate)
              ) {
                dates.push(recurrenceDate.format("YYYY-MM-DD"));
              }
              recurrenceDate.add(this.monthsRecurrence, "months");
            }
          }
        }
        this.$emit("setRecurrenceDates", [...dates]);
      }
    },
    watch: {
      initialDate() {
        const date = this.$moment(this.initialDate);
        this.dayOfMonth = date.date();

        // Get day of the week as number 1 to 7
        this.dayOfWeek = date.isoWeekday();
        const month = date.month();

        let current = this.$moment(date).startOf("month");
        let countWeek = 0;

        while (current.month() === month) {
          // Check if it is the same day as saved week to add 1 week
          if (current.isoWeekday() === this.dayOfWeek) {
            countWeek++;
            // Check if it is the date that we are searching and save the week and stop
            if (current.isSame(date, "day")) {
              this.weekOfMonth = countWeek;
              break;
            }
          }
          current.add(1, "day");
        }
      }
    }
  };
